module.exports = __webpack_public_path__ + "img/N1F10.c191ea45.jpg";